<template>
    <div>
      <!-- <Strong>HUB-Wise OFP Report</Strong> -->

      <b-row class="mt-5">
        <b-col cols="4">
          <b-form-group label="From Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="fromDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="To Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getHubOFPListing(1)"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:right;">
          <b-form-group>
            <button class="btn btn-primary" @click="performanceReport" :disabled="totalRows==0">Download </button>                       
          </b-form-group>
        </b-col>
      </b-row>
      
        <b-row class="my-2"> 

          <b-col sm="12" class="text-right">
            <b-col sm="12">  
              <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
            </b-col>
          </b-col>  
      
        <b-col sm="12">
          <b-table 
            show-empty 
            stacked="md"
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :bordered="bordered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
            </div> 

          </b-table>
        </b-col>

        <b-col sm="12" class="my-1 " v-if="this.totalRows > 10">
          <paginate
            v-model="currentPage"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </b-col> 
      </b-row> 
    </div>
</template>
  
<script>
import CONSTANTS from '@/utils/constants'
  export default {
    data: function(){
      return{
        name: 'hubWiseOFPReport',
        isBusy: false,
        items: [],
        fields: [
          {key:'hubname',label:'HUB Name'},
          {key:'created_date',label:'Created Date (DD-MM-YYYY)'},
          {key:'total_ofp_shipments',label:'Total Pickup Shipment'},
          {key:'total_ofp_exchange',label:'Total Pickup Exchange'},
          {key:'pickdone_shipments',label:'OFP Pickup Shipment'},
          {key:'pickdone_exchange_shipments',label:'OFP Pickup Exchange'},
          {key:'pickup_done_percentage',label:'Pickup Done Percentage'},
          {key:'pickup_cancel_percentage',label:'Pickup Cancel Percentage'},
          {key:'pickup_exchange_done_percentage',label:'Pickup Exchange Done Percentage'},
          {key:'pickup_exchange_cancel_percentage',label:'Pickup Exchange Cancel Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        searching:'',
        noofpages:'',
        pageNum:1,
        //codCollectionDate:'',
        toDate:new Date(),
        fromDate:new Date(),
        downloadreport:'',
        //isDownloadBtn: true,
      }
    },
    created: function(){
      this.getHubOFPListing(this.pageNum);
    },
    methods:{
      getHubOFPListing: function(page){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.isBusy = true;
        var hubId = userInfo.pickuplocationmasterid;

        if(this.fromDate > this.toDate){
          this.$fire({
            text: "From date must be smaller than To date",
            type: "warning",
            timer: 30000
          }); 
        }
        else{
          const Obj = {
            hub_id: hubId.toString(),
            fromdate: this.formatDate(this.fromDate),
            todate: this.formatDate(this.toDate),
            downloadAsCSV:false           
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFPPerformanceReport`,Obj)
          .then(result=>{
            if(result.body.returnmsg === 'Successful'){
              this.items = result.body.returnvalue;
              this.totalRows = result.body.total_records;
              this.noofpages = parseInt(this.totalRows)/10;
              this.noofpages = Math.ceil(this.noofpages);
              console.log("noofpages---->",this.noofpages)
            }
            else{
              this.items = [];
              this.totalRows = 0;
            }
            this.isBusy = false;
          })
          .catch(ex =>{
            console.log('error',ex)
          })
        }
      },

      performanceReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;

        const Obj={
          hub_id: hubId.toString(),
          fromdate: this.formatDate(this.fromDate),
          todate: this.formatDate(this.toDate),
          "downloadAsCSV":true    
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFPPerformanceReport`,Obj)
        .then(response=>{

          if(response.body){
            this.downloadReport(response.body)
          }
          else{
            this.downloadreport='';
          }   
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadReport(data){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'hubWiseOFPReport.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      formatDate: function(date) {
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },

      refresh(){
        this.fromDate = new Date();
        this.toDate = new Date();
        this.getHubOFPListing(1);
      },

      clickCallback: function(pageNum){
        //this.currentPage = pageNum;
        //this.getHubOFPListing(pageNum);
      },
    }
  };
</script>

<style>

</style>